import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./i18n"; // i18n must be imported before App
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import DataProvider from "./redux/store";

ReactDOM.render(
  <React.StrictMode>
    <DataProvider>
      <App />
    </DataProvider>
  </React.StrictMode>,
  document.getElementById("root"),
  () => {
    // Remove the inline loading skeleton once React has mounted
    const skeleton = document.getElementById("app-loading-skeleton");
    if (skeleton) {
      skeleton.style.transition = "opacity 0.3s ease";
      skeleton.style.opacity = "0";
      setTimeout(() => {
        if (skeleton && skeleton.parentNode) {
          skeleton.parentNode.removeChild(skeleton);
        }
      }, 300);
    }
  }
);

reportWebVitals();
